import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate, formatMonth } from '@/utils/format';
import type { FlatRateAgreement, Applicant, Consumer, TerminateRequest } from "../types";
import InfoDisplay from "@/components/InfoDisplay";
import SidebarNavigation from "@/components/SidebarNavigation";
import Layout from "../../shared/components/Layout";
import type { TerminateRequestParams } from "../types";
import clearLocalStorage from "@/utils/clearLocalStorage";
import createTerminate from "../api/createTerminate";

const TerminateConfirm: React.FC = () => {
  const { custCode } = useParams();

  const navigate = useNavigate();

  const [flatRateAgreement, setFlatRateAgreement] = useState<FlatRateAgreement>();
  const [applicant, setApplicant] = useState<Applicant>();
  const [consumer, setConsumer] = useState<Consumer>();
  const[terminateRequest, setTerminateRequest] = useState<TerminateRequest>({
    lensCollectionExpectedDate: "",
    endMonth: "",
    reasons: ""
  })

  useEffect(() => {
    const storedApplicant = localStorage.getItem("applicant");
    if(storedApplicant) {
      setApplicant(JSON.parse(storedApplicant));
    }

    const storedConsumer = localStorage.getItem("consumer");
    if(storedConsumer) {
      setConsumer(JSON.parse(storedConsumer));
    }

    const storedFlatRateAgreement = localStorage.getItem("flatRateAgreement");
    if(storedFlatRateAgreement) {
      setFlatRateAgreement(JSON.parse(storedFlatRateAgreement));
    }

    const storedTerminateRequest = localStorage.getItem("terminateRequest");
    if(storedTerminateRequest) {
      setTerminateRequest(JSON.parse(storedTerminateRequest));
    }

  }, []);

  const handleSubmit = async (e: React.MouseEvent<HTMLFormElement>) => {
    e.preventDefault()
    const params: TerminateRequestParams = {
      terminateRequest: terminateRequest
    }

    try {
      const res = await createTerminate(params, custCode);
      if(res.status === 201) {
        clearLocalStorage();

        navigate(`/facility/flat_rates/terminate_cancels/${custCode}/terminate/complete`);
      } else if(res.status !== 201) {
        navigate(`/facility/flat_rates/terminate_cancels/${custCode}/terminate`);
        window.scrollTo(0, 0)
        console.error(`status: ${res.status}, message: ${res.statusText}`);
      }

    } catch (err: any) {
      navigate(`/facility/flat_rates/terminate_cancels/${custCode}/terminate`);
      window.scrollTo(0, 0);
      console.log('An unexpected error occurred:', err.message);
    }
  }

  const renderPreviousPage = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    navigate(`/facility/flat_rates/terminate_cancels/${custCode}/terminate`, { state: { fromConfirmPage: true } });
    window.scrollTo(0, 0);
  }

  const displayPlan = (plan: string, price: string): string => {
    if(plan === 'both') return `両眼プラン(${price}円/月)`
    if(plan === 'right') return `片眼プラン(右眼)(${price}円/月)`
    if(plan === 'left') return `片眼プラン(左眼)(${price}円/月)`
    return '';
  }

  return (
    <Layout>
      <main className="wrapper" id="page-facility_login">
        <section className="sec-contact">
          <div className="inner">
            <h1 className="c-ttl__01">解約申込入力確認</h1>
            <div className="contact-box">
              <div className="contact-box__left">
                <div className="mbpc-98 mbsp-32">
                  <form onSubmit={handleSubmit}>
                    <div className="contact-box__form js-item" id="id-01">
                      <h2 className="c-ttl__02">お客様情報</h2>
                      <InfoDisplay label="契約種別" value={"定額制契約"} />
                      <InfoDisplay label="お客様ID" value={custCode} />
                      <InfoDisplay label="申込者名(カナ)" value={applicant?.nameKana} />
                      <InfoDisplay label="レンズ使用者名(カナ)" value={consumer?.nameKana} />
                    </div>
                    <div className="contact-box__form mbsp-29 js-item h-adr" id="id-02">
                      <h2 className="c-ttl__02">契約詳細</h2>
                      <InfoDisplay label="ご契約プラン" value={displayPlan(flatRateAgreement?.plan ?? '', flatRateAgreement?.price?.toString() ?? '')} />
                      <InfoDisplay label="サービス利用開始日" value={formatDate(flatRateAgreement?.startDate ?? '')} />
                      <InfoDisplay label="レンズ回収予定日" value={formatDate(terminateRequest.lensCollectionExpectedDate)} />
                      <InfoDisplay label="サービス利用終了月" value={formatMonth(terminateRequest.endMonth)} />
                      <InfoDisplay label="解約理由" value={terminateRequest.reasons} />
                    </div>
                    <button type="submit" className="c-btn__01">入力内容の確認</button>
                  </form>
                  <div className="c-al--c">
                    <button className="c-btn__02" onClick={renderPreviousPage}>前のページに戻る</button>
                  </div>
                </div>
              </div>
              <SidebarNavigation items={[
                { id: "id-01", label: "お客様情報" },
                { id: "id-02", label: "契約詳細" },
                ]} />
            </div>
          </div>
        </section>
      </main>
    </Layout>
  )
}

export default TerminateConfirm;